import { render, staticRenderFns } from "./ShareView.vue?vue&type=template&id=167b5a31&"
import script from "./ShareView.vue?vue&type=script&lang=ts&"
export * from "./ShareView.vue?vue&type=script&lang=ts&"
import style0 from "./ShareView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VChip,VContainer,VIcon,VImg})
